import { renderDonutForPdf, renderBarForPdf, drawChartRow } from "../pdfCharts";
import { BAR_PALETTE, DONUT_COLORS } from "../../../../utils/chartConfig";
import { formatWhole, formatMagnitudeAdaptiveAxis } from "../../../../utils/numberFormat";
import {
  buildGEIDonutData,
  buildGEIBarChartData,
  buildGEIBarChartDataIntensity,
} from "./TableGraf";

// Las 3 tarjetas de TableGraf.js (dona "Alcances" + barra "Emisiones" +
// barra "Intensidad") como SVG vectorial — misma lógica de datos que ya usa
// TableGraf.js en pantalla, reutilizada tal cual.
export async function renderGEITableGrafForPdf(totales, totalesScopes, valueBaseline, filters, t) {
  const donutData = buildGEIDonutData(totalesScopes, filters?.year);
  const [donut, barEmisiones, barIntensidad] = await Promise.all([
    renderDonutForPdf(donutData, DONUT_COLORS.gei),
    // Mismas reglas que TableGraf.js en pantalla: Regla 1 (sin decimales)
    // para el total de emisiones, Regla 2+ "eje" (sin ceros de más en
    // ticks redondos) para intensidad.
    renderBarForPdf(buildGEIBarChartData(totales), t("total_emissions_axis"), BAR_PALETTE, { yFormatter: formatWhole }),
    renderBarForPdf(buildGEIBarChartDataIntensity(totalesScopes, valueBaseline), t("emissions_intensity_axis"), BAR_PALETTE, { yFormatter: formatMagnitudeAdaptiveAxis }),
  ]);
  return { donut, barEmisiones, barIntensidad };
}

// Dibuja la fila de 3 tarjetas en el PDF — GEI solo tiene TableGraf.js
// (a diferencia de Efluentes/Residuos/Social, no hay secciones DualAxes
// adicionales).
export async function drawGEICustomCharts(doc, ctx, { totales, totalesScopes, valueBaseline, filters, t }) {
  const { margin, pageWidth, pageHeight, imgWidth } = ctx;
  let yOffset = ctx.yOffset;

  const { donut, barEmisiones, barIntensidad } = await renderGEITableGrafForPdf(totales, totalesScopes, valueBaseline, filters, t);
  const cards = [
    { title: t("scope_types"), ...donut },
    { title: t("annual_emissions"), ...barEmisiones },
    { title: t("emissions_intensity"), ...barIntensidad },
  ];
  const CHART_ROW_H = 210;
  if (CHART_ROW_H > pageHeight - margin - yOffset) {
    doc.addPage();
    yOffset = margin;
  }
  await drawChartRow(doc, cards, { x: margin, y: yOffset, availW: imgWidth, cardH: CHART_ROW_H, emptyMessage: t("no_data_available") });
  yOffset += CHART_ROW_H + 10;
  donut.cleanup?.();
  barEmisiones.cleanup?.();
  barIntensidad.cleanup?.();
  return yOffset;
}
